document.addEventListener('DOMContentLoaded', () => {
    // Menu toggle
    const toggleMenuButton = document.querySelector('.js-toggle-menu-button');
    if (toggleMenuButton) {
        const shadower = document.querySelector('.js-shadower');
        shadower.addEventListener('click', (e) => {
            e.stopPropagation();
            document.body.classList.remove('menu-open');
            document.body.classList.remove('noscroll');
        }, false);
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('js-toggle-menu-button')) {
                e.stopPropagation();
                document.body.classList.toggle('menu-open');
                document.body.classList.toggle('noscroll');
            }
        }, false);
    }
    // Scroll to next section anchor
    const smoothScrollHandler = (event) => {
        if (event.target.tagName.toLowerCase() !== 'a') {
            return false;
        }
        event.preventDefault();
        event.stopPropagation();

        document.querySelector(event.target.getAttribute('href')).scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        });
        return true;
    };
    const scrollBtn = document.querySelector('.js-scroll-link');
    if (scrollBtn) {
        scrollBtn.addEventListener('click', smoothScrollHandler);
    }
});
